
export default async function asyncQueue (promises: Array<Promise<any>>): Promise<any[]> {
    const results: any[] = []
    for (const promise of promises) {
        const result = await promise
        results.push(result)
    }
    return results
}
